import { Column, Index, OneToMany } from 'typeorm';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';
import { MSmClientOpportunityEntity } from './m-sm-client-opportunity.entity';

@Index('unique_name', ['mSmName'], { unique: true })
@Entity(
	'm_sm_client_opportunity_stage',
	{},
	{ label: 'Client Opportunity Stage' },
)
export class MSmClientOpportunityStageEntity extends BaseEntity {
	@Column('varchar', { name: 'm_sm_name', unique: true, length: 100 })
	public mSmName!: string;

	@Column('int', { name: 'm_sm_ordinal', unsigned: true, default: () => "'0'" })
	public mSmOrdinal!: number;

	@Column('int', {
		name: 'm_sm_probability',
		unsigned: true,
		default: () => "'50'",
	})
	public mSmProbability!: number;

	@OneToMany(
		() => MSmClientOpportunityEntity,
		(mSmClientOpportunity) =>
			mSmClientOpportunity.mSmFkMSmClientOpportunityStage,
		{},
	)
	public mSmClientOpportunities!: Array<MSmClientOpportunityEntity>;
}
